import React from "react"
import { DisplayValue } from "../../../utilities/displayValue"
import RaiStatusBadge from "../../shared_components/request_thread/RaiStatusBadge";
import { COPY } from "../../shared_components/request_thread/copy";

const STATUS_CHIP_STYLE = {
  display: 'inline-block',
  padding: '0.25rem 0.5rem',
  borderRadius: '4px',
  color: 'white',
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'uppercase',
};

const IssueRow = ({ issue, isSelected, toggleSelectIssue, onNavigate }) => {
  const overlay = issue.rai_status_overlay;
  const isClosedInfoRequested = overlay === 'closed_info_requested';

  return (
    <tr className={issue?.id ? 'cursor-pointer' : 'cursor-not-allowed'}>
      <td>
        <div className="flex justify-start align-center">
          <input
            type="checkbox"
            className="h-5 w-6"
            checked={isSelected}
            onChange={() => toggleSelectIssue()}
          />
        </div>
      </td>
      <td onClick={() => onNavigate(issue)}>
        <div>
          <span className='capitalize'>{DisplayValue(issue.patient_profile?.last_name)}</span>,
          <span className='capitalize'> {DisplayValue(issue.patient_profile?.first_name)}</span>
        </div>
        <div>
          {DisplayValue(issue.patient_profile?.gender)}
        </div>
        {DisplayValue(issue.patient_profile?.dob)}
        <div>
        </div>
        <div>
          {DisplayValue(issue.patient_profile?.personal_health_number)}
        </div>
      </td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue.primary_physician.name)}</td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue.get_consultant)}</td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue?.completed_at)}</td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue?.diagnosis)}</td>
      <td onClick={() => onNavigate(issue)}>
        {overlay ? (
          <RaiStatusBadge overlay={overlay} />
        ) : (
          !issue.is_open && (
            <span style={{ ...STATUS_CHIP_STYLE, backgroundColor: COPY.hex.closedBlue }}>
              {COPY.status.closed}
            </span>
          )
        )}
      </td>
      <td>
        {isClosedInfoRequested && (
          <button
            type="button"
            onClick={() => onNavigate(issue)}
            className="font-semibold text-white px-3 py-1 rounded uppercase text-xs"
            style={{ backgroundColor: COPY.hex.alertRed }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = COPY.hex.alertRedHover; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = COPY.hex.alertRed; }}
          >
            {COPY.buttons.view}
          </button>
        )}
      </td>
    </tr>
  )
}


export default IssueRow
